import { Component, ViewChild, input, booleanAttribute } from '@angular/core';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrl: './popover.component.scss',
})
export class PopoverComponent {
  @ViewChild('popover') popover!: Popover;

  title = input<string>('');
  showCloseIcon = input(true, {
    transform: booleanAttribute,
  });
  width = input<string>('350px');

  get overlayVisible(): boolean {
    return this.popover?.overlayVisible || false;
  }

  toggle(event: Event): void {
    this.popover?.toggle(event);
  }

  show(event?: Event): void {
    this.popover?.show(event);
  }

  hide(): void {
    this.popover?.hide();
  }
}
